// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes pulsate-bck {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(0.9);
    }
    100% {
        transform: scale(1);
    }
}

.pulsate-bck {
    animation: pulsate-bck 0.8s ease-in-out infinite both;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/animation.css"],"names":[],"mappings":"AAcA;IACI;QAEI,mBAAmB;IACvB;IACA;QAEI,qBAAqB;IACzB;IACA;QAEI,mBAAmB;IACvB;AACJ;;AAEA;IAEI,qDAAqD;AACzD","sourcesContent":["@-webkit-keyframes pulsate-bck {\n    0% {\n        -webkit-transform: scale(1);\n        transform: scale(1);\n    }\n    50% {\n        -webkit-transform: scale(0.9);\n        transform: scale(0.9);\n    }\n    100% {\n        -webkit-transform: scale(1);\n        transform: scale(1);\n    }\n}\n@keyframes pulsate-bck {\n    0% {\n        -webkit-transform: scale(1);\n        transform: scale(1);\n    }\n    50% {\n        -webkit-transform: scale(0.9);\n        transform: scale(0.9);\n    }\n    100% {\n        -webkit-transform: scale(1);\n        transform: scale(1);\n    }\n}\n\n.pulsate-bck {\n    -webkit-animation: pulsate-bck 0.8s ease-in-out infinite both;\n    animation: pulsate-bck 0.8s ease-in-out infinite both;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
